import { ENDPOINTS } from "../config/apiConfig"; // Import the API base URL
import axiosInstance from "../config/axiosInstance";

interface ApiResponse {
  answer: string;
}

export const apiService = {
  sendMessage: async (
    prompt: string,
    sessionId: string,
    userId: string,
    rerunNUmber: number = 0,
    questionId: any = null,
    pregenerated_questions: string | null = null
  ): Promise<any> => {
    try {
      const response = await axiosInstance.post<ApiResponse>(
        ENDPOINTS.chat + "/chat",
        {
          prompt,
          session_id: sessionId || "", // Send empty string if no sessionId
          user_id: userId, // Always send userId
          rerun_number: rerunNUmber,
          question_id: questionId,
          pregenerated_questions,
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw new Error("Unable to process your request at this moment!");
    }
  },
};

export const getUserActiveSession = async (payload: any) => {
  try {
    const response = await axiosInstance.get(
      `${ENDPOINTS.chat}/getSessionChatHistory?session_id=${payload.session_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch active session");
  }
};

export const resetUserSession = async (sessionId: string, userId: string) => {
  try {
    const payload = {
      session_id: sessionId,
      user_id: userId,
    };
    const response = await axiosInstance.put(
      ENDPOINTS.chat + "/resetSession",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    throw new Error("Failed to reset chat session");
  }
};

export const regenerateMessage = async (
  prompt: string,
  userId: string,
  sessionId: string,
  questionId: string
) => {
  try {
    const response = await axiosInstance.post(ENDPOINTS.chat + "/chat", {
      prompt,
      user_id: userId,
      session_id: sessionId,
      question_id: questionId,
    });

    return response.data;
  } catch (error) {
    throw new Error("Failed to regenerate response");
  }
};

export const sendFeedback = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      ENDPOINTS.chat + "/sendFeedback",
      payload
    );
    return response.data; // Assuming API responds with success
  } catch (error) {
    throw error;
  }
};

export const getChatSessions = async (page: number, limit: number) => {
  try {
    const response = await axiosInstance.get(
      `${ENDPOINTS.chat}/getChatSessions?page=${page}&limit=${limit}`
    );
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching chat history:", error);
    throw new Error("Failed to fetch chat history");
  }
};

export const updateSessionName = async (payload: any) => {
  try {
    const response = await axiosInstance.put(
      ENDPOINTS.chat + "/updateSessionName",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error updating chat session:", error);
    throw new Error("Failed to update chat session");
  }
};

export const deleteSession = async (payload: { session_id: string }) => {
  try {
    const response = await axiosInstance.delete(
      `${ENDPOINTS.chat}/deleteSession`,
      { data: payload }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting session:", error);
    throw new Error("Failed to delete chat session");
  }
};
